import store from '../store'
import router from '../router'
import { generateIndexRouter } from "./util";
import { Userinfo } from '@/request/login'
import { timeFix } from "@/utils/util";
import { notification } from 'ant-design-vue'


//设置动态路由
export function setDynamicMenu() {
    return new Promise((resolve, reject) => {
        store.dispatch("GetInfo", { Userinfo: Userinfo }).then((res) => {
            notification.success({
                message: "欢迎",
                description: `${timeFix()}，欢迎回来`,
                duration: 4
            });
            var menu = generateIndexRouter(res.data.role_menu);
            // console.log(JSON.parse(JSON.stringify(menu)));
            //存储动态路由
            router.addRoutes(menu);
            resolve(menu)
        }).catch(() => {
            reject()
        })
    })
}